var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WCard',{staticClass:"ImportGenerate pos-r"},[_c('WLoading',{attrs:{"text":this.$t('imports.create.generate.default'),"visible":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }